import { useState } from "react"
import { FileDownload } from "@mui/icons-material"
import { Menu, MenuItem } from "@mui/material"
import { ExportCsv, ExportExcel, ExportPrint, ToolbarButton } from "@mui/x-data-grid-premium"
import Tooltip from "components/material/tooltip"

export default function ExportMenu() {
  const [anchorEl, setAnchorEl] = useState(null)

  return <>
    <Tooltip title="Export">
      <span>
        <ToolbarButton
          id="export-menu-trigger"
          aria-controls="export-menu"
          aria-haspopup="true"
          aria-expanded={anchorEl ? "true" : undefined}
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <FileDownload fontSize="small" />
        </ToolbarButton>
      </span>
    </Tooltip>
    <Menu
      id="export-menu"
      anchorEl={anchorEl}
      open={!!anchorEl}
      onClose={() => setAnchorEl(null)}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        list: {
          "aria-labelledby": "export-menu-trigger",
        },
      }}
    >
      <ExportCsv options={{ escapeFormulas: false }} render={<MenuItem />}>Download as CSV</ExportCsv>
      <ExportExcel render={<MenuItem />}>Download as Excel</ExportExcel>
      <ExportPrint render={<MenuItem />}>Print</ExportPrint>
    </Menu>
  </>
}
